import { render, staticRenderFns } from "./StartPageQuiz.vue?vue&type=template&id=691ed94f&scoped=true&"
import script from "./StartPageQuiz.vue?vue&type=script&lang=js&"
export * from "./StartPageQuiz.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "691ed94f",
  null
  
)

export default component.exports